import React from "react";
import ImageWithHotspot from "./ImageWithHotspot";
import * as modalStyles from "../UI/ImageModal/ImageModal.module.scss";
import usePopupImage from "../BowerModal/usePopupImage";
const LaundryImageWithHotspot = (props) => {
  let { images, onHotspotClick } = props;

  return (
    <ImageWithHotspot
      heading="Utility Room"
      subheading="8.1% of household plastic waste"
      onHotspotClick={onHotspotClick}
      images={images}
      imageName="laundry_01"
      hoverImageName="laundry_01_hover"
      hotspots={[
        {
          popupImages: usePopupImage(images, "orange", "utility"),

          imageName: "laundry_02",
          mobileImageName: "mobile_laundry",

          x: 33.4,
          y: 12.63,
          averageWaste: "3.9 kg.",
          tooltipBackground: "",
          popupTableData: {
            "Fabric Conditioner": "0.79 kg.",
            "Laundry Liquid": "0.22 kg.",
            "Laundry Bleach": "0.28 kg.",
            "Glass Cleaner": "0.56 kg.",
            "Surface Sanitiser": "0.56 kg.",
            "Limescale Spray": "0.56 kg.",
            "Floor Cleaner": "0.42 kg.",
            "Bathroom Cleaner": "0.56 kg.",
          },
          popupContent: {
            heading: "Utility Room",
            p1: "   Who knew that softening your clothes was so hard on the planet? Those large fabric conditioner bottles account for 20% of the room's overall single-use plastic contribution. Glass and mirror cleaner and surface sanitiser are the next biggest felons, accounting for 14.2% of the rooms plastic output each.          ",
          },
        },
      ]}
    />
  );
};

export default LaundryImageWithHotspot;
